import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-amount',
  templateUrl: './fpx-amount.component.html',
  styleUrls: ['./fpx-amount.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxAmountComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxAmountComponent extends BaseFpxControlComponent {
  
  isOthers: boolean = false;
  isJOD: boolean = false;
  isJPY: boolean = false;
  temp: boolean;
  seperatorLength: any = 0;
  maskText:any = 'separator.';
  amountMaskFormat:any = '';

  _currencyCode:string;
  @Input()
  set currencyCode(currency:string) {
    this._currencyCode = currency;
    this.updateFormat(this._currencyCode);
  }
  get currencyCode(){
    return this._currencyCode;
  }

  constructor(controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef, private _renderer: Renderer2) {
    super(controlContainer, changeDetectorRef);
  }

  protected doPreInit(): void {
    this.addDependencies(this.dependencyField);
    this.updateFormat(this.currencyCode);
  }

  updateFormat(currency:string){
    switch (currency) {
      case "JOD":
        this.seperatorLength = 3;
        break;
      case "JPY":
        this.seperatorLength = 0;
        break;
      default:
        this.seperatorLength = 2;
        break;
    }

    this.amountMaskFormat = this.maskText + this.seperatorLength;
  }

  protected doChangeNotify(subject: string, payload: any): void {
    console.log("fpx-amount do change notification", subject, payload);
    this.currencyCode = payload[subject];
  }

}
